import { NsKey } from 'enums/NsKey';
import { Sizes } from 'enums/sizes';
import { useDynamicTranslation } from 'hooks/useDynamicTranslation';
import { usePanel } from 'hooks/usePanel';
import { useCallback } from 'react';
import { BorrowerRealEstatePanel } from '../../forms/borrower/real-estate/BorrowerRealEstatePanel';
import { useBorrowerGlobalInfos } from '../../store';
import { useBorrowerRealEstateId } from '../../store/borrowerSelectors';

interface UseBorrowerRealEstateOptions {
  borrowerProjectId?: string;
}

export const useBorrowerRealEstate = (
  onRefresh?: () => void,
  options?: UseBorrowerRealEstateOptions
) => {
  const { openPanel, closePanel } = usePanel();
  const { t } = useDynamicTranslation([NsKey.Contractualization]);
  const globalInfos = useBorrowerGlobalInfos();
  const currentBienId = useBorrowerRealEstateId();

  const personneId = globalInfos?.insured?.id ?? undefined;
  const insuredAddress = globalInfos?.insured?.address ?? undefined;
  const borrowerProjectId = options?.borrowerProjectId;

  const openRealEstatePanel = useCallback(() => {
    if (!personneId || !borrowerProjectId) return;

    openPanel(
      {
        title: t('CONTRACTUALIZATION.REAL_ESTATE.PANEL_TITLE'),
        size: Sizes['2xl']
      },
      <BorrowerRealEstatePanel
        personneId={personneId}
        borrowerProjectId={borrowerProjectId}
        currentBienId={currentBienId}
        insuredAddress={insuredAddress}
        onRefresh={() => onRefresh?.()}
        onClose={closePanel}
      />
    );
  }, [openPanel, closePanel, t, personneId, borrowerProjectId, currentBienId, insuredAddress, onRefresh]);

  return {
    openRealEstatePanel,
    isEnabled: Boolean(personneId && borrowerProjectId)
  };
};
